import { createContext, useContext, useState } from 'react';
import { Props, SleepUniqueOptions, SleepUniqueOptionsContextValues } from '../../types/config-types';

export const OptionsContext = createContext<Partial<SleepUniqueOptionsContextValues>>({
  config: { api_base_url: null, catalog_results_base_url: null, questions: [], facts: [] },
  setConfig: () => {},
});
const { Provider } = OptionsContext;

export const OptionsProvider = ({ children }: Props) => {
  const [config, setConfig] = useState<SleepUniqueOptions>({
    api_base_url: null,
    catalog_results_base_url: null,
    questions: [],
    facts: [],
  });

  return <Provider value={{ config, setConfig }}>{children}</Provider>;
};

export const useOptionsContext = () => {
  const context = useContext(OptionsContext);

  if (!context) throw Error('useOptionsContext should be used within an OptionsProvider');

  return context;
};
